import { render, staticRenderFns } from "./commonTableAttach.vue?vue&type=template&id=29337a9a&"
import script from "./commonTableAttach.vue?vue&type=script&lang=js&"
export * from "./commonTableAttach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports